import React, { useState, useEffect } from 'react'
import { Plus, Edit, Trash2, Calendar, MapPin, Users } from 'lucide-react'
import { supabase } from '../../lib/supabase'
import { Session } from '../../types/database'

export function SessionsManagement() {
  const [sessions, setSessions] = useState<Session[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchSessions()
  }, [])

  const fetchSessions = async () => {
    try {
      const { data, error } = await supabase
        .from('sessions')
        .select(`
          *,
          stage:stages(*),
          center:centers(*)
        `)
        .order('start_date', { ascending: false })

      if (error) throw error
      setSessions(data || [])
    } catch (err) {
      console.error('Error fetching sessions:', err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Gestion des Sessions</h1>
        </div>
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestion des Sessions</h1>
          <p className="text-gray-600">Créer et gérer les sessions de vacances</p>
        </div>
        <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Plus className="h-4 w-4" />
          <span>Nouvelle session</span>
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          <div className="text-center text-gray-500">
            <Calendar className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Fonctionnalité à développer</h3>
            <p>La gestion complète des sessions sera implémentée ici :</p>
            <ul className="mt-4 text-sm text-left max-w-md mx-auto space-y-2">
              <li>• Création de nouvelles sessions</li>
              <li>• Modification des sessions existantes</li>
              <li>• Gestion des capacités et tarifs</li>
              <li>• Attribution aux centres et stages</li>
              <li>• Planification des dates</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}